<ng-container *ngIf="initialized">

  <!--
      EMBED THE FORM
  -->

  <mvs-crud-object-form
    [importObjectContextDto]="importObjectContextDto"
    [dto]="dto"
    [form]="form"
    [formErrors]="apiErrors"
    [objectType]="objectType"
    [createMode]="createMode"
    [widgetLayoutConfig]="widgetLayoutConfig"
    [crudService]="crudService"
    [readonly]="readonly"
    [disabled]="disabled"
    [sgUseCaseId]="sgUseCaseId"
    [busy]="busy"
    [removeDelete]="removeDelete"
    [autoSaveMode]="autoSaveMode"
    [autoSaveDebounceMs]="autoSaveDebounceMs"
    [inPlaceUpdate]="inPlaceUpdate"
    (lifecycleEvents)="handleLifeCycleEvent($event)"
    [templates]="templates"
    [defaultCreateDto]="defaultCreateDto"
    [formControlOverwrite]="formControlOverwrite"
    [formMode]="formMode"
    [formFooterButtons]="formFooterButtons"
    [forceHideModes]="forceHideModes"
    (onFooterButtonClick)="handleButtonClick($event)"
    [enableBack]="enableBack"
    [formFooterCustomButtons]="formFooterCustomButtons"
    [hideDefaultActions]="hideDefaultActions"
    [hideHistoryAction]="hideHistoryAction"
    [hideAuditAction]="hideAuditAction"
    [hideActionBar]="hideActionBar"
    (onBackEvent)="onBack()"
    (onFormDirty)="handleFormDirty($event)"
    (onFormChange)="handleFormChange($event)"
    (onFormSubmitStateChange)="handleFormSubmitStateChange($event)"
    (onFormStateChange)="handleFormStateChange($event)"
    (onFormTargetFocus)="handleFormTargetFocus($event)"
    (onTemplateRefresh)="handleTemplateRefresh($event)"
    [softDeletedNotice]="softDeletedNotice"
    (onUndoSoftDelete)="onUndoSoftDeleteFromForm($event)"
  ></mvs-crud-object-form><!-- TM-1000001714 -->


</ng-container>
